import { FormFieldSelect } from 'global/components/Form'
import { useAuth } from 'hooks'

interface IProps {
    required?: boolean
}

export function SelectCategorias({ required }: IProps) {
    const {
        decoded: { categoria },
    } = useAuth()

    return (
        <FormFieldSelect
            required={required}
            name="categoriaId"
            label="Categoria de acesso"
            options={[
                { value: 3, label: 'Cliente' },
                { value: 6, label: 'Avaliação' },
                ...(categoria !== 7
                    ? [{ value: 7, label: 'Representante' }]
                    : []),
            ]}
        />
    )
}
